import messageChannelService from '../message-channel.service'
import { logInfo, logError } from '../../../utilities/pinpad-v2/logger'

class VoucherService {
  async printVoucher(params) {
    const payload = {
      Ambiente: params?.Ambiente,
      VoucherComercio: params?.VoucherComercio,
      VoucherCliente: params?.VoucherCliente,
      ModeloTerminal: params?.ModeloTerminal
    }

    if (!payload.Ambiente) {
      const error = new Error('Missing required parameter: Ambiente')
      error.code = 'INVALID_PARAMETERS'
      throw error
    }

    try {
      logInfo('Starting printVoucher operation', {
        ambiente: payload.Ambiente,
        modeloTerminal: payload.ModeloTerminal,
        hasVoucherCliente: !!payload.VoucherCliente,
        hasVoucherComercio: !!payload.VoucherComercio,
        voucherClienteLength: String(payload.VoucherCliente || '').length,
      })

      const response = await messageChannelService.sendMessage('printVoucher', payload, 60000)

      logInfo('printVoucher response received', {
        response,
      })

      return response
    } catch (error) {
      logError('printVoucher failed', error, {
        ambiente: payload.Ambiente,
        modeloTerminal: payload.ModeloTerminal,
        hasVoucherCliente: !!payload.VoucherCliente,
        hasVoucherComercio: !!payload.VoucherComercio,
        voucherClienteLength: String(payload.VoucherCliente || '').length,
      })
      throw error
    }
  }

  async getRspVoucherComercio() {
    try {
      logInfo('Starting getRspVoucherComercio operation')
      const response = await messageChannelService.sendMessage('getRspVoucherComercio', {}, 30000)
      const voucher = typeof response === 'string' ? response : response?.voucher_comercio || response?.voucher || ''
      return this.cleanVoucherText(voucher)
    } catch (error) {
      logError('getRspVoucherComercio failed', error)
      throw error
    }
  }

  async getRspVoucherCliente() {
    try {
      logInfo('Starting getRspVoucherCliente operation')
      const response = await messageChannelService.sendMessage('getRspVoucherCliente', {}, 30000)
      const voucher = typeof response === 'string' ? response : response?.voucher_cliente || response?.voucher || ''
      return this.cleanVoucherText(voucher)
    } catch (error) {
      logError('getRspVoucherCliente failed', error)
      throw error
    }
  }

  cleanVoucherText(voucher) {
    if (!voucher) return ''

    return String(voucher)
      .replace('@cnb logo_cpagos', '')
      .replace('@cnn ver_app', '')
      .replace(/@cnb /g, '')
      .replace(/@cnn /g, '')
      .replace(/@br /g, '')
      .replace(/@lnn /g, '')
      .replace(/@bc /g, '')
      .trim()
  }

  hasIntegratedPrinter(pinpadData) {
    return pinpadData?.impresora === '1' || pinpadData?.Printer === '1'
  }
}

const voucherService = new VoucherService()

export default voucherService
